





































import { Component, Vue, Prop } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';

@Component
export default class EventHeaderComponent extends Vue {
  @Prop({ required: true })
  eventUi!: EventUI;

  get event_info_place(): string {
    return typeof this.eventUi.event.info.place === 'string'
      ? this.eventUi.event.info.place
      : this.eventUi.event.info.place?.name || '';
  }
}
